module.exports = __webpack_public_path__ + "static/media/left-chevron.7b8b0265.png";